import { useAtomValue } from 'infrastructure/state/jotai.wrapper'
import { partnerIdAtom } from './atoms'
import { openTab } from '../Helpers'
import { previewUrl } from 'infrastructure/api'
import { Button } from '@mui/material'
import * as React from 'react'

export function IngestedPreviewButton({
  ingestionKey,
}: {
  ingestionKey: string
}) {
  const partnerKey = useAtomValue(partnerIdAtom)
  return (
    <Button onClick={() => openTab(previewUrl({ partnerKey, ingestionKey }))}>
      Open Preview
    </Button>
  )
}
